/**
 * Cliente API de notificaciones del vecino — Sprint 11 v2 S11-V2-15.
 *
 * Consume los endpoints del Bell del Header:
 * - GET    /vecino/notificaciones
 * - GET    /vecino/notificaciones/count-no-leidas
 * - POST   /vecino/notificaciones/{id}/marcar-leida
 * - POST   /vecino/notificaciones/marcar-todas-leidas
 */
import { apiFetch } from './client';

// Espejo de TIPOS_VALIDOS en app/models/notificacion_vecino.py. El Bell
// renderiza titulo/mensaje genéricamente (no hace switch por tipo), pero el
// union se mantiene sincronizado para que el tipo sea honesto.
export type TipoNotificacion =
  | 'morosidad'
  | 'cierre_semestral'
  | 'pago_aprobado'
  | 'aviso_nuevo'
  | 'solicitud_recurso_aprobada'
  | 'solicitud_recurso_rechazada'
  | 'cierre_tenencia'
  | 'reprogramacion_citofonia'
  | 'reprogramacion_wifi'
  | 'validacion_aprobada'
  | 'validacion_rechazada'
  | 'onboarding_enviado';

export interface NotificacionVecino {
  id: string;
  tipo: TipoNotificacion;
  titulo: string;
  mensaje: string;
  enlace_destino: string | null;
  meta_json: Record<string, unknown> | null;
  creada_at: string;
  leida_at: string | null;
}

export interface CountNoLeidasResponse {
  count: number;
}

export interface MarcarLeidaResponse {
  id: string;
  leida_at: string;
}

export interface MarcarTodasLeidasResponse {
  marcadas: number;
}

export function listarNotificaciones(
  opciones: { leidas?: boolean; limit?: number } = {},
): Promise<NotificacionVecino[]> {
  const params = new URLSearchParams();
  if (opciones.leidas !== undefined) {
    params.set('leidas', String(opciones.leidas));
  }
  if (opciones.limit !== undefined) {
    params.set('limit', String(opciones.limit));
  }
  const qs = params.toString();
  return apiFetch<NotificacionVecino[]>(
    `/vecino/notificaciones${qs ? `?${qs}` : ''}`,
  );
}

export function contarNoLeidas(): Promise<CountNoLeidasResponse> {
  return apiFetch<CountNoLeidasResponse>(
    '/vecino/notificaciones/count-no-leidas',
  );
}

export function marcarLeida(
  notificacionId: string,
): Promise<MarcarLeidaResponse> {
  return apiFetch<MarcarLeidaResponse>(
    `/vecino/notificaciones/${notificacionId}/marcar-leida`,
    { method: 'POST' },
  );
}

export function marcarTodasLeidas(): Promise<MarcarTodasLeidasResponse> {
  return apiFetch<MarcarTodasLeidasResponse>(
    '/vecino/notificaciones/marcar-todas-leidas',
    { method: 'POST' },
  );
}
